import { Component } from '@angular/core';
import {LoadingController, NavController, NavParams} from 'ionic-angular';
import {WorkReportProvider} from "../../providers/work-report/work-report";
import {ToastProvider} from "../../providers/toast/toast";
import {ValidationProvider} from "../../providers/validation/validation";
import {SearchListItemPage} from "../search-list-item/search-list-item";
import {ErrorListProvider} from "../../providers/error-list/error-list";

/**
 * Generated class for the WorkReportEditPartListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


const distinct = (value, index, self) => {
  return self.indexOf(value) === index;
};


@Component({
  selector: 'page-work-report-edit-part-list',
  templateUrl: 'work-report-edit-part-list.html',
})
export class WorkReportEditPartListPage {

  mode: string;
  workReport: any = {};
  part: any = {};
  salesOrder: any = {};

  // mostlyOkLists: any = [];
  // errorLists: any = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private loadingCtrl: LoadingController,
    private workReportProvider: WorkReportProvider,
    private errorListProvider: ErrorListProvider,
    private validation: ValidationProvider,
    private toast: ToastProvider
  )
  {
    this.mode = this.navParams.get('mode');
    this.part = this.navParams.get('part');
    this.workReport = this.navParams.get('workReport');
    this.salesOrder = this.navParams.get('salesOrder');
  }

  ionViewDidLoad() {
    this.errorListProvider.selectedErrorList = null;
  }

  ionViewDidEnter() {
    if (this.errorListProvider.selectedErrorList != null) {
      if (this.errorListProvider.insertErrorListMode == 'NA') {
        this.part.error_id2.error_line_ids[this.errorListProvider.insertErrorListIndex].mostly_ok_list_id = this.errorListProvider.selectedErrorList;
      } else if (this.errorListProvider.insertErrorListMode == 'NA-sub') {
        if (!this.part.error_id2.error_line_ids[this.errorListProvider.insertErrorListIndex].mostly_items)
          this.part.error_id2.error_line_ids[this.errorListProvider.insertErrorListIndex].mostly_items = [];
        this.part.error_id2.error_line_ids[this.errorListProvider.insertErrorListIndex].mostly_items.push(this.errorListProvider.selectedErrorList);
      } else if (this.errorListProvider.insertErrorListMode == 'NIO') {
        this.part.error_id.error_line_ids[this.errorListProvider.insertErrorListIndex].error_list_id = this.errorListProvider.selectedErrorList;
      } else if (this.errorListProvider.insertErrorListMode == 'NIO-sub') {
        if (!this.part.error_id.error_line_ids[this.errorListProvider.insertErrorListIndex].error_items)
          this.part.error_id.error_line_ids[this.errorListProvider.insertErrorListIndex].error_items = [];
        this.part.error_id.error_line_ids[this.errorListProvider.insertErrorListIndex].error_items.push(this.errorListProvider.selectedErrorList);
      }
      this.errorListProvider.selectedErrorList = null;
    }
  }

  validate() {
    this.validation.init();

    // Validate total count
    if (this.mode == 'NA' || this.mode == 'NIO') {
      let entryErrors = [];
      let sum = 0;
      let errorLineIds = [];
      let totalCount = 0;

      if (this.mode == 'NA') {
        errorLineIds = this.part.error_id2.error_line_ids;
        totalCount = this.part.part_mostly_ok;
      }  else if (this.mode == 'NIO') {
        errorLineIds = this.part.error_id.error_line_ids;
        totalCount = this.part.part_not_ok;
      }

      for (let entry of errorLineIds) {
        if (this.mode == 'NA') {
          if (!entry.mostly_ok_list_id)
            entryErrors.push('Wählen Sie eine NA - Liste aus.');
        } else if (this.mode == 'NIO') {
          if (!entry.error_list_id)
            entryErrors.push('Wählen Sie eine Fehlerliste aus.')
        }

        sum += parseInt(entry.count);
      }

      entryErrors = entryErrors.filter(distinct);

      for (let entryError of entryErrors) {
        this.validation.addError(entryError);
      }

      if (sum != totalCount) {
        this.validation.addError('Die gesamte Anzahl muss die Summe aus den einzelnen Einträgen ergeben.');
      }
    }
  }

  async saveAndGoBack() {
    this.validate();

    if (this.validation.isValid) {
      let loading = this.loadingCtrl.create({content: "Teileliste wird gespeichert, bitte warten ..."});
      loading.present();

      let success = await this.workReportProvider.savePart(this.workReport.name, this.part, null);

      loading.dismiss();

      if (!success) {
        this.toast.error('Teileliste konnte nicht gespeichert werden, es ist ein Fehler aufgetreten.');
      } else {
        this.navCtrl.pop();
      }
    } else {
      this.validation.showMessages();
    }
  }

  newNAListItem() {
    this.part.error_id2.error_line_ids.push({
      id: 0,
      mostly_ok_list_id: 0,
      name: '',
      // mostly_items: 0,
      count: 0
    });
  }

  removeNAListItem(index) {
    this.part.error_id2.error_line_ids.splice(index, 1);
  }

  newNIOListItem() {
    this.part.error_id.error_line_ids.push({
      id: 0,
      error_list_id: 0,
      name: '',
      // mostly_items: 0,
      count: 0
    });
  }

  removeNIOListItem(index) {
    this.part.error_id.error_line_ids.splice(index, 1);
  }

  removeMostlyOkItem(error_line_index, index) {
    this.part.error_id2.error_line_ids[error_line_index].mostly_items.splice(index, 1);
  }

  removeErrorItem(error_line_index, index) {
    this.part.error_id.error_line_ids[error_line_index].error_items.splice(index, 1);
  }

  goToSearchListItem(index, mode) {
    this.errorListProvider.insertErrorListIndex = index;
    this.errorListProvider.insertErrorListMode = mode;

    this.navCtrl.push(SearchListItemPage, {
      mode: mode,
      salesOrder: this.salesOrder
    });
  }

}




// WEBPACK FOOTER //
// ./src/pages/work-report-edit-part-list/work-report-edit-part-list.ts